/**
 * NO04 - Ordre Search API Calls
 */

import axios, { AxiosRequestConfig } from 'axios';
import { NO04SearchParams } from '../models/NO04';
import Utils from './Utils';

const timeout = 30000;

export const searchOrders = (searchParams: NO04SearchParams) => {
  const backendParams: any = {
    CompanyId: searchParams.companyId,
    Page: searchParams.page ?? 0,
    PageSize: searchParams.pageSize ?? 100,
  };

  if (searchParams.matchAnyNumber)      backendParams.MatchAnyNumber      = true;
  if (searchParams.orderNumber)         backendParams.OrderNumber         = searchParams.orderNumber;
  if (searchParams.customerNumber)      backendParams.CustomerNumber      = searchParams.customerNumber;
  if (searchParams.requisitionNumber)   backendParams.RequisitionNumber   = searchParams.requisitionNumber;
  if (searchParams.invoiceCreditNumber) backendParams.InvoiceCreditNumber = searchParams.invoiceCreditNumber;
  if (searchParams.fromDate)            backendParams.From                = searchParams.fromDate;
  if (searchParams.toDate)              backendParams.To                  = searchParams.toDate;

  const config: AxiosRequestConfig = {
    method: 'get',
      baseURL: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/orders/summary`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: backendParams,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
  };
  return axios.request(config);
};

export const fetchOrderDetail = (companyId: number, orderNumber: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
      baseURL: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/Order/detail`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: { orderNumber, companyId },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
  };
  return axios.request(config);
};
